<template lang="pug">
  section.asu-download(:class="'page-' + page")
    #cover-page.download-page
      .cover-header.layout.row.wrap
        .title-program.flex.offset-md4.md8.xs12
          span(v-if="page === 'participa'") ASU PARTICIPA
          span(v-if="page === 'costera'") ASU COSTERA
          span(v-if="page === 'viva'") ASU VIVA
      LineMultiColorHeaderSeparator
      .layout.row.cover-body.wrap
        .img-container.flex.md4
          .logoprogram
            img(v-if="page === 'participa'" src="@/assets/img/asuparticipa.png")
            i.ap-Asu-costera(v-if="page === 'costera'")
            img(v-if="page === 'viva'" src="@/assets/img/asuviva.png")
            .information(v-if="page === 'viva'")
              a(href="https://www.asuviva.com/" target="_blank") www.asuviva.com
        .flex.md8
          .description
            .description-header.center
              h1.programs-page-title Documentos
            .description-body
              DownloadPanel.download-panel(:documents="documents" :baseUrl="`/documents/asu/${page}/`")

</template>

<script>
import ProgramService from '@/services/programs.js'
import DownloadPanel from '@/components/DownloadPanel'
import goToBackMixin from '@/mixins/go-back-home.js'

export default {
  name: 'AsuDownload',
  mixins: [goToBackMixin],
  components: { DownloadPanel },
  props: ['page'],
  mounted () {
    this.documents = ProgramService.getPrograms()[this.page].documents
  },
  data () {
    return {
      code: '',
      documents: []
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

.isMobile .img-container
  height auto !important

.asu-download
  width: 100%
  height: 100%
  margin: 100px 0
  overflow-x: hidden

.cover-body
  .flex.md4
    height: 20vmax
    height: 20vw

.logoprogram
  text-align: center

.page-costera .logoprogram
  padding-top: $f35px
  .ap-Asu-costera
    color: $color_5
    font-size: $f68px

.page-viva .logoprogram
  img
    margin-top: -75px
  .information
    margin-top: -94px

.information
  border-radius: 20px

.programs-page-title
  font-weight: bold

</style>
